import Styled from 'styled-components';

export const TitleModal = Styled.div`
  width: 100%;
  padding: 16px;
  margin-bottom: 5px;
  h1 {
    font-size: 32px;
    line-height: 1;
    margin: 0;
  }
`;

export const Wrapper = Styled.div`
  width: 600px;
  padding: 0 48px 32px;
  background-color: #fff;

  @media (max-width: 800px) {
    margin: 16px 0;
    width: 100%;
  }

  p {
    margin-bottom: 16px;
    color: #555;
    font-size: 14px;
    line-height: 22px;
  }
`;

export const ButtonWrapper = Styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  button {
    width: 215px;
    height: 48px;
    position: relative;
    svg {
      position: absolute;
      right: 28px;
      width: 24px;
    }
  }
  > .secondary button {
    width: 140px;
    min-width: 140px;
    margin-right: 16px;
  }
`;

export const FileInputArea = Styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: fit-content;
`;

export const ResultWrapper = Styled.div`
  margin-top: 16px;
`;

export const CounterRow = Styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #231f20;
`;

export const ErrorList = Styled.ul`
  margin-top: 8px;
  padding-left: 16px;
  max-height: 200px;
  overflow-y: auto;

  li {
    font-size: 13px;
    color: #555;
    margin-bottom: 4px;
    line-height: 1.4;
  }
`;
